import { useEffect, useCallback } from 'react';
import { Capacitor } from '@capacitor/core';
import { Keyboard, KeyboardResize } from '@capacitor/keyboard';

/**
 * Configura il plugin Keyboard di Capacitor.
 * Imposta il resize su `native` in ambiente Android (configurabile)
 * e offre una funzione per nascondere la barra accessoria su iOS.
 */
export const useCapacitorKeyboard = (
  resizeMode: KeyboardResize = KeyboardResize.Native,
) => {
  useEffect(() => {
    if (!Capacitor.isPluginAvailable('Keyboard')) return;

    if (Capacitor.getPlatform() === 'android') {
      Keyboard.setResizeMode({ mode: resizeMode }).catch(() => {});
    }
  }, [resizeMode]);

  const hideAccessoryBar = useCallback(() => {
    if (Capacitor.isPluginAvailable('Keyboard')) {
      Keyboard.setAccessoryBarVisible({ isVisible: false }).catch(() => {});
    }
  }, []);

  return { hideAccessoryBar };
};
